import { render, staticRenderFns } from "./Instancing.vue?vue&type=template&id=5653e69b&scoped=true&lang=pug&"
import script from "./Instancing.ts?vue&type=script&lang=ts&"
export * from "./Instancing.ts?vue&type=script&lang=ts&"
import style0 from "./Instancing.vue?vue&type=style&index=0&id=5653e69b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5653e69b",
  null
  
)

export default component.exports